import { FaTachometerAlt, FaUsers } from "react-icons/fa";
import { useState } from "react";

export default function Sidebar({ setPage }) {
  const [active, setActive] = useState("dashboard");

  const handleClick = (page) => {
    setActive(page);
    setPage(page);
  };

  const menuItem = (name, label, icon) => (
    <div
      onClick={() => handleClick(name)}
      className={`sidebar-item d-flex align-items-center gap-2 ${
        active === name ? "active" : ""
      }`}
    >
      {icon}
      <span>{label}</span>
    </div>
  );

  return (
    <div className="sidebar d-flex flex-column">

      {/* 🔥 LOGO / TITLE */}
      {/* <div className="sidebar-header text-center">
        <h5 className="text-white fw-semibold">Liver Admin</h5>
        <small className="text-light">Healthcare Panel</small>
      </div> */}

      {/* 🔥 MENU */}
      <div className="mt-4 px-2">
        {menuItem("dashboard", "Dashboard", <FaTachometerAlt />)}
        {menuItem("users", "Patients", <FaUsers />)}
      </div>

    </div>
  );
}